<template>
  <div>
    <h3 class="mb-2">My requests</h3>
    <hr>
    <span v-if="!purchases || purchases.length === 0">No request</span>
    <div class="table-responsive">
      <table class="table table-striped m-b-0" v-if="purchases.length > 0">
        <thead>
          <tr>
            <th>Data catalog</th>
            <th>Date</th>
            <th>Price</th>
            <th width="1%"></th>
          </tr>
        </thead>
        <tbody>
          <tr :key="purchase._id" v-for="(purchase, index) in purchases">
            <td>
              <router-link :to="{ name: 'Product', params: { slug: purchase.product.slug }}">{{ purchase.product.name }}</router-link>
            </td>
            <td>{{ purchase.created | moment('YYYY-MM-DD')}}</td>
            <td>{{ (purchase.price === 0) ? 'Free' : purchase.price }}</td>
            <td class="with-btn" nowrap>
              <router-link :to="{ name: 'EditReviewProfile', params: { id: purchase._id }}" class="btn btn-sm btn-primary get-started rounded-pill">review</router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  name: 'Purchases',
  data() {
    return {
      purchases: []
    }
  },
  created: function () {
    this.fetchData().then(purchases => (this.purchases = purchases.filter(purchase => purchase.product)))
  },
  methods: {
    fetchData() {
      return this.$http
        .get('purchase', { params: { populate: 'product' } })
        .then(
          response => {
            return response.data
          }, () => {}
        )
    }
  }
}
</script>
<style>
.get-started {
  background: #E95913 !important;
}
.get-started:hover {
  background:  #E95913af !important;
}</style>


// WEBPACK FOOTER //
// src/pages/profile/Purchases.vue